export default __webpack_public_path__ + "static/media/faishal-edited.0ad721d1.png";